import { render, staticRenderFns } from "./iconText.vue.html?vue&type=template&id=23974353&scoped=true&"
import script from "./iconText.ts?vue&type=script&lang=ts&"
export * from "./iconText.ts?vue&type=script&lang=ts&"
import style0 from "./iconText.vue?vue&type=style&index=0&id=23974353&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23974353",
  null
  
)

export default component.exports